<h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
  {{this.localiser.get("select_floorplans.sureToDelete")}}<br>
  {{this.localiser.get("select_floorplans.sureToDelete2")}}
</h1>

<div mat-dialog-content class="bodyForm" style="height: 80%">
  <div class="middleText">
    <div class="row rowForm" style="margin-bottom: 4%">
      <div class="col">
        <h4 class="textS">{{this.localiser.get("devices.floorplan")}}</h4>
        <h4 class="textS underline">{{this.data.floorplan.nombre}}</h4>
      </div>
      <div class="col">
        <h4 class="textS">{{this.localiser.get("devices.project")}}</h4>
        <h4 class="textS underline">{{this.data.proyecto.nombre}}</h4>
      </div>
    </div>

    <img width="50%" src="{{this.data.floorplan.imagenPlano}}">

  </div>
</div>

<div mat-dialog-actions style="height: 10%">
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>

  <div class="col" style="text-align: center">
    <button class="customButtonColorDelete textS" mat-button (click)="deleteFloorplan()">{{this.localiser.get("button.delete")}}</button>
  </div>
</div>
